import "./App.css";
import { ComingSoonPage } from "./components/ComingSoonPage";

function App() {
  return (
    <div className="App">
      <ComingSoonPage />
    </div>
  );
}

export default App;
